import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MenuItem, useLink, useModal } from '@shapeable/ui';
import { DcoDoingsIconGlyph } from '../icons/dco-doings-icon';
import { isMailchimpModalSlug, showMailchimpModal } from './mailchimp-modal';

const cls = classNames('user-menu-items');

// -------- Types -------->

// -------- Props -------->

export type LoggedOutUserMenuItemsProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const LoggedOutUserMenuItemsDefaultProps: Omit<LoggedOutUserMenuItemsProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MenuItem)<ContainerProps>`${ContainerStyles}`,
};

export const LoggedOutUserMenuItems: Shapeable.FC<LoggedOutUserMenuItemsProps> = (props) => {
  const { 
    className, children, entity, 
  } = props;

  const modal = useModal();

  const onHeaderButtonClick = () => {
      showMailchimpModal(modal);
  }
  
  return (
    <My.Container 
      className={cls.name(className)}
      label='Sign Up'
      onClick={onHeaderButtonClick}
      iconComponent={DcoDoingsIconGlyph}
      >
    {children}
    </My.Container>
  )
};

LoggedOutUserMenuItems.cls = cls;